export default function () {
  const dt = date => {
    if (!date) {
      return new Date();
    }
    if (typeof date.getMonth === "function") {
      return date;
    } else {
      return new Date(date.substring(0, 19));
    }
  };

  const getDateFlightfox = d => {
    var date = dt(d);
    var dow = new Intl.DateTimeFormat("en", { weekday: "short" }).format(date);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    var month = new Intl.DateTimeFormat("en", { month: "short" }).format(date);
    return dow + ", " + day + " " + month;
  };

  const getDateFlightfoxFull = d => {
    var date = dt(d);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(date);
    var month = new Intl.DateTimeFormat("en", { month: "short" }).format(date);
    var year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(date);
    return day + " " + month + ", " + year;
  };

  const getDurationAccommodationNights = (date1, date2) => {
    var days = getDurationCalendarDays(date1, date2);
    return days == 1 ? days + " Night" : days + " Nights";
  };

  const getDurationCalendarDays = (date1, date2) => {
    var dt1 = dt(date1).setHours(12);
    var dt2 = dt(date2).setHours(12);
    var diff = dt2 - dt1;
    var days = Math.round(diff / (1000 * 60 * 60 * 24));
    return days;
  };

  const getDurationCountdown = date => {
    var periodFactors = [1000, 60, 60, 24, 7, 52.143];
    var periodLabels = ["s", "m", "h", "d", "w", "y"];

    var dt1 = new Date(date);
    var dt2 = new Date();
    var isFuture = dt1 > dt2;
    var milliseconds = isFuture ? dt1 - dt2 : dt2 - dt1;
    var result = getDurationMessageFn(periodFactors, periodLabels, milliseconds, periodFactors.length);

    return isFuture ? result : result + " ago";
  };

  const getDurationItineraryDates = (date1, date2) => {
    var dt1 = new Date(date1);
    var dt2 = new Date(date2);
    var minutes = (dt2 - dt1) / 1000 / 60;
    return getDurationMinutes(minutes);
  };

  const getDurationMessage = date => {
    var periodFactors = [1000, 60, 60, 24, 7, 52.143];
    var periodLabels = ["s", "m", "h", "d", "w", "y"];

    var dt1 = new Date(date);
    var dt2 = new Date();
    var milliseconds = dt2 - dt1;
    var result = getDurationMessageFn(periodFactors, periodLabels, milliseconds, periodFactors.length);

    return result + " ago";
  };

  const getDurationMessageFn = (factors, labels, milliseconds, length) => {
    var check = milliseconds;
    var i = 0;

    // Check that we have a full number for first period
    for (i = 0; i < length; i++) {
      check = check / factors[i];
    }

    // If so, return the formated value
    if (check > 1 || length == 1) {
      // Calculate first period
      var p1 = Math.round(check);
      return p1 + labels[length - 1];
    }

    return getDurationMessageFn(factors, labels, milliseconds, length - 1);
  };

  const getDurationMinutes = minutes => {
    var days,
      hrs = 0;

    // If >= 1 day
    days = minutes / 60 / 24;
    if (days >= 1) {
      days = Math.floor(minutes / 60 / 24);
      hrs = Math.round((minutes - days * 24 * 60) / 60);
      return days + "d";
    }

    // If >= 1 hour
    hrs = minutes / 60;
    if (hrs > 1) {
      hrs = Math.round(hrs);
      return hrs + "h";
    }

    // If < 1 hour
    return minutes + "m";
  };

  const getOvernights = (date1, date2) => {
    var days = getDurationCalendarDays(date1, date2);

    if (days > 0) {
      return "+" + days;
    } else if (days < 0) {
      return "-" + days;
    }

    return;
  };

  const getTime = date => {
    var hours = date.substring(11, 13);
    var minutes = date.substring(14, 16);
    var postfix = hours >= 12 ? "pm" : "am";
    var hours12 = hours % 12 || 12;
    return hours12 + ":" + minutes + postfix;
  };

  const utilDateFlightfox = date => {
    var d = dt(date);
    var dow = new Intl.DateTimeFormat("en", { weekday: "short" }).format(d);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
    var month = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
    return dow + ", " + day + " " + month;
  };

  const utilDateFlightfoxUTC = d => {
    var date = dt(d.substr(0, 10));
    var dow = new Intl.DateTimeFormat("en", { weekday: "short", timeZone: "UTC" }).format(date);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit", timeZone: "UTC" }).format(date);
    var month = new Intl.DateTimeFormat("en", { month: "short", timeZone: "UTC" }).format(date);
    return dow + ", " + day + " " + month;
  };

  const utilDateTimezone = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset();

    if (offset === 0) return "00:00";
    const offsetSign = offset > 0 ? "-" : "+"; // Invert sign because the offset is reversed in JS
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;

    const formattedOffset = `${offsetSign}${offsetHours.toString().padStart(2, "0")}:${offsetMinutes.toString().padStart(2, "0")}`;
    return formattedOffset;
  };

  const utilDateYYMMDD = date => {
    return dt(date).toLocaleString("sv-SE", { timeZoneName: "short" }).split(" ")[0];
  };

  const utilDateOffsetVolume = (date, offset, csv) => {
    var d = dt(date);

    // Calculate the offset in minutes
    const [hours, minutes] = offset.split(":");
    const totalOffsetMinutes = parseInt(hours) * 60 + parseInt(minutes);

    // Apply the offset to the date
    d.setMinutes(d.getMinutes() + totalOffsetMinutes);

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

    // // Format the date to Sat, Jun 01 06:00
    const dayOfWeek = days[d.getDay()];
    const year = d.getFullYear();
    const month = csv === void 0 ? months[d.getMonth()] : (d.getMonth() + 1).toString().padStart(2, "0");
    const day = d.getDate().toString().padStart(2, "0");
    const hour = d.getHours().toString().padStart(2, "0");

    if (csv === void 0) return `${dayOfWeek}, ${month} ${day} ${hour}:00`;

    return `${year}-${month}-${day} ${hour}:00`;
  };

  const utilDurationItineraryDates = (date1, date2) => {
    var dt1 = new Date(date1);
    var dt2 = new Date(date2);
    var minutes = (dt2 - dt1) / 1000 / 60;
    return getDurationMinutes(minutes);
  };

  const utilDurationAccommodationNights = (date1, date2) => {
    var days = utilDurationCalendarDays(date1, date2);
    return days == 1 ? days + " Night" : days + " Nights";
  };

  const utilDurationCalendarDays = (date1, date2) => {
    var dt1 = dt(date1).setHours(12);
    var dt2 = dt(date2).setHours(12);
    var diff = dt2 - dt1;
    var days = Math.round(diff / (1000 * 60 * 60 * 24));
    return days;
  };

  const utilDurationFlightOvernights = (date1, date2) => {
    var days = utilDurationCalendarDays(date1, date2);
    if (days == 0) {
      return;
    }
    return (days > 0 ? "+" : "-") + days;
  };

  const utilDurationItineraryMinutes = minutes => {
    var days,
      hrs,
      mins = 0;

    // If > 24 hours
    days = minutes / 60 / 24;
    if (days > 1) {
      days = Math.floor(minutes / 60 / 24);
      hrs = Math.round((minutes - days * 24 * 60) / 60);
      return days + "d " + hrs + "h";
    }

    // If < 24 hours
    hrs = Math.floor(minutes / 60);
    mins = Math.round(minutes % 60);

    return hrs + "h " + mins + "m";
  };

  const utilDurationMessage = date => {
    var periodFactors = [1000, 60, 60, 24, 7, 52.143];
    var periodLabels = ["s", "m", "h", "d", "w", "y"];

    var dt1 = new Date(date);
    var dt2 = new Date();
    var milliseconds = dt2 - dt1;
    var result = utilDurationMessageFn(periodFactors, periodLabels, milliseconds, periodFactors.length);

    return result + " ago";
  };

  const utilDurationMessageFn = (factors, labels, milliseconds, length) => {
    var check = milliseconds;
    var i = 0;

    // Check that we have a full number for first period
    for (i = 0; i < length; i++) {
      check = check / factors[i];
    }

    // If so, return the formated value
    if (check > 1 || length == 1) {
      // Calculate first period
      var p1 = Math.round(check);
      return p1 + labels[length - 1];
    }

    return utilDurationMessageFn(factors, labels, milliseconds, length - 1);
  };

  const utilTime = date => {
    var hours = date.substring(11, 13);
    var minutes = date.substring(14, 16);
    var postfix = hours >= 12 ? "pm" : "am";
    var hours12 = hours % 12 || 12;
    return hours12 + ":" + minutes + postfix;
  };

  const utilDateApi = date => {
    var d = dt(date);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
    var month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
    var year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    return year + "/" + month + "/" + day;
  };

  const utilDateISO8601 = date => {
    var d = dt(date);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
    var month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
    var year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    return year + "-" + month + "-" + day;
  };
  const utilDateFlightfoxShort = date => {
    var d = dt(date);
    var day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
    var month = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
    return day + month;
  };
  const utilDateFlightfoxShortUTC = date => {
    var d = dt(date.substr(0, 10));
    var day = new Intl.DateTimeFormat("en", { day: "2-digit", timeZone: "UTC" }).format(d);
    var month = new Intl.DateTimeFormat("en", { month: "short", timeZone: "UTC" }).format(d);
    return day + month;
  };

  const utilDateFromISO = isoString => {
    // Extract YYYY-MM-DD from ISO string and convert to YYYY/MM/DD
    // Avoids timezone conversion issues
    if (!isoString) return '';
    const dateOnly = isoString.substring(0, 10);
    return dateOnly.replace(/-/g, '/');
  };

  const utilDateFlightSearchAPI = date => {
    // Standardized date format for flight search API: YYYY-MM-DD
    // Handles both Date objects and string inputs
    var d;
    var useUTC = false;

    if (typeof date === 'string') {
      // If it's a string, parse it as UTC to avoid timezone issues
      if (date.includes('T') || date.endsWith('Z')) {
        // Already has time component or is explicitly UTC
        d = new Date(date);
      } else {
        // Date-only string like "2025-09-29" - treat as UTC midnight
        d = new Date(date + 'T00:00:00Z');
      }
      useUTC = true;
    } else if (typeof date.getMonth === "function") {
      // Already a Date object from date picker - use local timezone
      d = date;
      useUTC = false;
    } else {
      // Fallback for other types
      d = new Date(date);
      useUTC = true;
    }

    // Format using UTC for strings, local for Date objects from picker
    var day, month, year;
    if (useUTC) {
      day = new Intl.DateTimeFormat("en", { day: "2-digit", timeZone: "UTC" }).format(d);
      month = new Intl.DateTimeFormat("en", { month: "2-digit", timeZone: "UTC" }).format(d);
      year = new Intl.DateTimeFormat("en", { year: "numeric", timeZone: "UTC" }).format(d);
    } else {
      day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
      month = new Intl.DateTimeFormat("en", { month: "2-digit" }).format(d);
      year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
    }
    return year + "-" + month + "-" + day;
  };

  return {
    getDateFlightfox,
    getDateFlightfoxFull,
    getDurationAccommodationNights,
    getDurationCountdown,
    getDurationItineraryDates,
    getDurationMessage,
    getDurationMinutes,
    getOvernights,
    getTime,
    utilDateFlightfox,
    utilDateFlightfoxUTC,
    utilDateTimezone,
    utilDateYYMMDD,
    utilDateOffsetVolume,
    utilDurationItineraryDates,
    utilDurationAccommodationNights,
    utilDurationCalendarDays,
    utilDurationFlightOvernights,
    utilDurationItineraryMinutes,
    utilDurationMessage,
    utilDurationMessageFn,
    utilTime,
    utilDateApi,
    utilDateISO8601,
    utilDateFlightfoxShort,
    utilDateFlightfoxShortUTC,
    utilDateFromISO,
    utilDateFlightSearchAPI,
  };
}
